import React, { useState, useEffect } from 'react';
import queryString from 'query-string';

import LocationOption from '../../../_components/Options/LocationOption';
import ProfessionalOption from '../../../_components/Options/ProfessionalOption';

function SearchComponent({ location, handleSearch, handleClear }) {
  const queryParams = queryString.parse(location.search);

  const [firstName, setFirstName] = useState(queryParams.firstName || '');
  const [lastName, setLastName] = useState(queryParams.lastName || '');
  const [professional, setProfessional] = useState(queryParams.professional ? parseInt(queryParams.professional) : '');
  const [locationId, setLocation] = useState(queryParams.location ? parseInt(queryParams.location) : '');

  useEffect(() => {
    const queryParams = queryString.parse(location.search);

    setFirstName(queryParams.firstName || '');
    setLastName(queryParams.lastName || '');
    setProfessional(queryParams.professional ? parseInt(queryParams.professional) : '')
    setLocation(queryParams.location ? parseInt(queryParams.location) : '');
  }, [location.search])

  return <>
    <div className="col">
      <input onChange={e => setFirstName(e.target.value)}
        onKeyPress={e => {
          if (e.key === 'Enter') {
            handleSearch({ firstName, lastName, professional, locationId });
          }
        }}
        value={firstName}
        type="text" className="form-control" placeholder="First Name" />
    </div>
    <div className="col">
      <input onChange={e => setLastName(e.target.value)}
        onKeyPress={e => {
          if (e.key === 'Enter') {
            handleSearch({ firstName, lastName, professional, locationId });
          }
        }}
        value={lastName}
        type="text" className="form-control" placeholder="Last Name" />
    </div>
    <div className="col">
      <ProfessionalOption defaultValue={professional}
        handleSelected={(professional) => {
          setProfessional(professional);
        }} />
    </div>
    <div className="col">
      <LocationOption defaultValue={locationId}
        handleSelected={(location) => {
          setLocation(location);
        }} />
    </div>
    <div className="col">
      <button onClick={() => {
        handleSearch({ firstName, lastName, professional, locationId });
      }} type="button" className="btn btn-primary mr-2">Search</button>
      <button onClick={handleClear} type="button" className="btn btn-outline-primary">Clear</button>
    </div>
  </>
}

export default SearchComponent;